"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const Colors_1 = __importDefault(require("../../assets/colors/Colors"));
const helpler_1 = require("../../utils/helpler");
const scale_1 = require("../../utils/scale");
const CustomText_1 = __importDefault(require("../text/CustomText"));
const ModalConfirm = (props) => {
    const { visible, onClose, title, content, onConfirm, confirmLabel, cancelLabel } = props;
    return (react_1.default.createElement(react_native_1.Modal, { visible: visible, animationType: "fade", statusBarTranslucent: true, transparent: true, onRequestClose: () => {
            onClose();
        }, ...props, onShow: () => {
            helpler_1.isWeb && document.body.classList.add("prevent-slice-modal");
        }, onDismiss: () => {
            helpler_1.isWeb && document.body.classList.remove("prevent-slice-modal");
        } },
        react_1.default.createElement(react_native_1.View, { style: styles.viewContain },
            react_1.default.createElement(react_native_1.View, { style: styles.viewModal },
                react_1.default.createElement(react_native_1.View, { style: {
                        width: '100%',
                        alignItems: 'center',
                        paddingHorizontal: (0, scale_1.scale)(16),
                    } },
                    react_1.default.createElement(CustomText_1.default, { weight: "600", style: {
                            width: '100%',
                            fontSize: (0, scale_1.moderateScale)(16),
                            lineHeight: (0, scale_1.moderateScale)(24),
                            textAlign: 'center',
                        } }, title),
                    react_1.default.createElement(CustomText_1.default, { style: {
                            fontSize: (0, scale_1.moderateScale)(14),
                            lineHeight: (0, scale_1.moderateScale)(21),
                            marginTop: (0, scale_1.scale)(16),
                            textAlign: 'center',
                        } }, content)),
                react_1.default.createElement(react_native_1.View, { style: {
                        marginTop: (0, scale_1.scale)(24),
                        height: (0, scale_1.scale)(48),
                        borderTopWidth: 1,
                        borderTopColor: '#DDDDDD',
                        width: '100%',
                        flexDirection: 'row',
                    } },
                    react_1.default.createElement(react_native_1.TouchableOpacity, { style: styles.buttonCancel, onPress: () => onClose() },
                        react_1.default.createElement(CustomText_1.default, { style: styles.textCancel }, cancelLabel || 'キャンセル')),
                    react_1.default.createElement(react_native_1.TouchableOpacity, { style: [styles.buttonConfirm, { borderRightWidth: 0 }], onPress: () => onConfirm() },
                        react_1.default.createElement(CustomText_1.default, { style: styles.textConfirm }, confirmLabel || '削除')))))));
};
const styles = react_native_1.StyleSheet.create({
    textCancel: {
        color: '#007AFF',
        fontSize: (0, scale_1.moderateScale)(16),
        lineHeight: (0, scale_1.moderateScale)(24),
    },
    buttonCancel: {
        width: '50%',
        height: '100%',
        borderRightWidth: 1,
        borderRightColor: '#DDDDDD',
        justifyContent: 'center',
        alignItems: 'center',
    },
    buttonConfirm: {
        width: '50%',
        height: '100%',
        borderRightWidth: 1,
        borderRightColor: '#DDDDDD',
        justifyContent: 'center',
        alignItems: 'center',
    },
    textConfirm: {
        color: '#D32F2F',
        fontSize: (0, scale_1.moderateScale)(16),
        lineHeight: (0, scale_1.moderateScale)(24),
    },
    textError: {
        fontWeight: '600',
        color: Colors_1.default.textHeader,
        textAlign: 'center',
        fontSize: (0, scale_1.moderateScale)(22),
        marginTop: (0, scale_1.verticalScale)(8),
        marginBottom: (0, scale_1.verticalScale)(10),
    },
    iconX: {
        alignSelf: 'flex-end',
    },
    iconFaceError: {
        marginTop: (0, scale_1.verticalScale)(23),
    },
    textHere: {
        color: Colors_1.default.secondaryColor,
        textDecorationLine: 'underline',
    },
    textNote: {
        fontWeight: '300',
        fontSize: (0, scale_1.moderateScale)(14),
        color: Colors_1.default.tertiaryOrange,
        marginBottom: (0, scale_1.verticalScale)(10),
    },
    viewModal: {
        backgroundColor: 'white',
        width: (0, scale_1.scale)(343),
        alignItems: 'center',
        borderRadius: (0, scale_1.scale)(12),
        paddingTop: (0, scale_1.scale)(24),
    },
    viewContain: {
        flex: 1,
        backgroundColor: Colors_1.default.textHeaderOpacity60,
        justifyContent: 'center',
        alignItems: 'center',
    },
    buttonMiddle: {
        height: (0, scale_1.scale)(32),
        width: (0, scale_1.scale)(84),
    },
    buttonSelect: {
        height: (0, scale_1.scale)(32),
        width: (0, scale_1.scale)(84),
    },
    vItem: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        borderBottomWidth: 1,
        borderBottomColor: Colors_1.default.gray2,
        marginBottom: 5,
        paddingVertical: 8,
        width: (0, scale_1.scale)(400),
    },
    textItem1: {
        fontSize: (0, scale_1.moderateScale)(17),
        fontWeight: '300',
        color: Colors_1.default.black1,
        marginRight: (0, scale_1.scale)(10),
        flex: 7,
        includeFontPadding: false,
    },
    vNext: {
        flexDirection: 'row',
        alignItems: 'center',
        flex: 1,
    },
    vList: {
        marginTop: (0, scale_1.verticalScale)(15),
    },
    textItem2: {
        fontSize: (0, scale_1.moderateScale)(15),
        fontWeight: '300',
        color: Colors_1.default.blueStrong,
        textDecorationLine: 'underline',
        includeFontPadding: false,
    },
});
exports.default = ModalConfirm;
